/**
 * 根据企业id获取某一层级下的所有部门
 */
import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';
import { IDepartListInfo } from './interface';
import { DEPARTMENT_ACCESS } from '@umu/umu-types';

export interface IParams {
    source?: string;
    type?: DEPARTMENT_ACCESS;
}

export const getDepartmentListByManagerId = (data: IParams) => {
    if (!data.type) {
        delete data.type;
    }
    return fetchData(Api.GET_DEPARTMENTS_BY_MANAGERID, data).then((res: IResponse<IDepartListInfo>) => {
        return res.data;
    });
};
